/**
 * Анимация статистики на детальной матча
 */
$.fn.animateStatistic = function() {
    const $self = $(this);
    const $progressHolder = $self.find('.js-progress-percents');
    const $amountHolder = $self.find('.js-progress-amount');
    const $svgHolder = $self.find('.js-radial-graphic');


    const sectionTop = $self.offset().top;
    let windowBottom = $(window).scrollTop() + $(window).height();

    /**
     * Установить кол-во процентов для графика
     */
    const setPercents = () => {
        if ($progressHolder.length) {
            $progressHolder.each(function() {
                const percents = $(this).data('percents');
                $(this).css('width', `${percents}%`)
            });
        }
    };

    /**
     * Анимированно устанавливаем кол-во
     */
    const animateAmount = () => {
        if ($amountHolder.length) {
            $amountHolder.each(function() {
                const amount = $(this).data('amount');
                let countInterval;
                let counter = 0;
                countInterval = setInterval(() => {

                    if (counter === amount) {
                        clearInterval(countInterval);
                    } else {
                        counter++;
                        $(this).text(counter);
                    }
                }, 500/amount);
            });
        }
    };

    /**
     * Установить атрибуты путей
     */
    const setPathAttributes = () => {
        if ($svgHolder.length) {
            $svgHolder.each(function () {
                const path = $(this).find('.js-path').get(0);
                const totalLength = path.getTotalLength();
                $(path).css({
                    'stroke-dashoffset': totalLength,
                    'stroke-dasharray' : totalLength
                });
            });
        }
    };

    /**
     * Заполнить график
     */
    const fulfillGraphic = () => {
        if ($svgHolder.length) {
            $svgHolder.each(function () {
                const path = $(this).find('.js-path').get(0);
                const percents = $(this).data('percents');
                const totalLength = path.getTotalLength();
                const lengthToSet = totalLength / 100 * percents;
                $(path).css({
                    'stroke-dashoffset':  totalLength + lengthToSet
                });
            });
        }
    };

    /**
     * Инициализация ивентов
     */
    const initEvents = () => {
        if (window.innerWidth >= 1920) {
            $(document).on('scroll', function () {
                windowBottom = $(window).scrollTop() + $(window).height();
                if (windowBottom > sectionTop && !$self.hasClass('animated')) {
                    setPercents();
                    animateAmount();
                    fulfillGraphic();
                    $self.addClass('animated')
                }
            });
        }

        if (window.innerWidth < 1920) {
            $('.js-protocols-layout').on('scroll', function () {
                windowBottom = $(this).scrollTop() + $(this).height();
                const sectionTop = $self.offset().top - $(this).offset().top;

                if (windowBottom > sectionTop && !$self.hasClass('animated')) {
                    setPercents();
                    animateAmount();
                    fulfillGraphic();
                    $self.addClass('animated')
                }
            })
        }

    };

    /**
     * Инициализация
     */
    const init = () => {
        setPathAttributes();
      if (windowBottom > sectionTop && !$self.hasClass('animated')) {
          setPercents();
          animateAmount();
          fulfillGraphic();
          $self.addClass('animated')
      }
      initEvents();
    };

    init();

};
